import React, { useState } from 'react';

const Education = ({ educations, onRemove, onEdit, onAddNew }) => {
  return (
    <div className="form-section">
      <div className="section-header">
        <h2 className="section-title green">Education</h2>
        <button
          onClick={onAddNew}
          className="btn btn-primary"
        >
          Add Education
        </button>
      </div>
      {educations.map((education, index) => (
        <div key={index} className="education-card">
          <div className="education-card-content">
            <div className="education-info">
              <h3 className="education-title">{education.degree}</h3>
              <p className="education-institution">{education.institution}</p>
              {education.fieldOfStudy && (
                <p className="education-field">{education.fieldOfStudy}</p>
              )}
              <p className="education-date">
                {education.startDate} - {education.endDate}
              </p>
              {education.location && (
                <p className="education-location">{education.location}</p>
              )}
              {education.grade && (
                <p className="education-grade">Grade: {education.grade}</p>
              )}
              {education.description && (
                <p className="education-description">{education.description}</p>
              )}
            </div>
            <div className="education-actions">
              <button
                onClick={() => onEdit(education, index)}
                className="btn btn-secondary btn-small"
              >
                Edit
              </button>
              <button
                onClick={() => onRemove(index)}
                className="btn btn-danger btn-small"
              >
                Remove
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Education; 